import { getLoadingMessage } from '../../shared/utils'

const defaultState = {
  error: '',
  formMetric: {},
  loading: true,
  formDefinitionLoading: true,
  message: getLoadingMessage(),
  selectedTime: 'last_thirty_days',
  dateRange: [],
  browsersData: {
    'chrome': {
      name: 'Chrome',
      usage: 0,
      percent: 0
    },
    'firefox': {
      name: 'Firefox',
      usage: 0,
      percent: 0
    },
    'safari': {
      name: 'Safari',
      usage: 0,
      percent: 0
    },
    'edge': {
      name: 'Microsoft Edge',
      usage: 0,
      percent: 0
    },
    'internet-explorer': {
      name: 'Internet Explorer',
      usage: 0,
      percent: 0
    },
    'opera': {
      name: 'Opera',
      usage: 0,
      percent: 0
    },
    'android-browser': {
      name: 'Android Webview',
      usage: 0,
      percent: 0
    },
    'opera-mini': {
      name: 'Opera Mini',
      usage: 0,
      percent: 0
    },
    'samsung-browser': {
      name: 'Samsung Internet',
      usage: 0,
      percent: 0
    },
    'uc-browser': {
      name: 'UC Browser',
      usage: 0,
      percent: 0
    },
    'yandex-browser': {
      name: 'Yandex',
      usage: 0,
      percent: 0
    },
    'others': {
      name: 'Others',
      usage: 0,
      percent: 0
    }
  },
  mapsApiKey: 'AIzaSyDUIdfbeR1K_Eq878CTz3UDPQ58Gr5US4s'
}

export default function analyticsReducers (state=defaultState, action) {
  const { type, payload } = action
  switch (type) {
    case 'FETCH_FORM_ANALYTICS_START':
    case 'FETCH_FORM_ANALYTICS_SUCCESS':
    case 'FETCH_FORM_ANALYTICS_FAILURE':
    case 'FETCH_FORM_DEFINITION_FOR_ANALYTICS_START':
    case 'FETCH_FORM_DEFINITION_FOR_ANALYTICS_SUCCESS':
    case 'FETCH_FORM_DEFINITION_FOR_ANALYTICS_FAILURE':
      return { ...state, ...payload };

    default: {
      return state
    }
  }
}